"use strict";

exports.__esModule = true;
exports.radioGroupPropTypes = exports.radioPropTypes = void 0;

var _propTypes = require("prop-types");

var _constants = require("./constants");

var radioPropTypes = {
  checked: _propTypes.bool,
  className: _propTypes.string,
  defaultChecked: _propTypes.bool,
  disabled: _propTypes.bool,
  hideLabel: _propTypes.bool,
  inputRef: _propTypes.func,
  invalid: _propTypes.bool,
  justify: _propTypes.bool,
  label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]).isRequired,
  labelPosition: (0, _propTypes.oneOf)(Object.keys(_constants.LABEL_POSITION)),
  name: _propTypes.string,
  onChange: _propTypes.func,
  required: _propTypes.bool,
  rootProps: _propTypes.object,
  size: (0, _propTypes.oneOf)(Object.keys(_constants.SIZE)),
  value: _propTypes.string
};
exports.radioPropTypes = radioPropTypes;
var radioGroupPropTypes = {
  checked: _propTypes.string,
  children: _propTypes.node,
  data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element]).isRequired,
    value: _propTypes.string.isRequired
  })),
  defaultChecked: _propTypes.string,
  inline: _propTypes.bool,
  name: _propTypes.string.isRequired,
  onChange: _propTypes.func,
  rootProps: _propTypes.object
};
exports.radioGroupPropTypes = radioGroupPropTypes;